$(document).ready(function() {
    function initializeSlick() {
      if ($(window).width() < 768) {
        $('.lp-qr__carousel').each(function() {
          if (!$(this).hasClass('slick-initialized')) {
            $(this).slick({
              infinite: true,
              speed: 300,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              autoplay: true,
            }).show();
          }
        });
      } else {
        $('.lp-qr__carousel').each(function() {
          if ($(this).hasClass('slick-initialized')) {
            $(this).slick('unslick');
          }
        });
      }
    }

    initializeSlick();

    $(window).resize(function() {
      initializeSlick();
    });


    $('#reviews-tab .nav-link').each(function() {
        $(this).on('click', function (e) {
          console.log('clicked')
       initializeSlick();
      }); 
    });
  


    //add mystery item to cart
    $('#add-to-cart-item').on('click', function(event) {
      event.preventDefault();  
      var mysteryvariantId = $(this).data('variant-id'); 
      var mysteryedirectUrl = $(this).attr('href');   
      var mysteryquantity = 1;         
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: mysteryquantity,
          id: mysteryvariantId
        },
        dataType: 'json',
        success: function(response) { 
          console.log('Product added to cart:', response); 
          window.location.href = mysteryedirectUrl;
        },
        error: function(xhr, status, error) { 
          console.error('Error adding product to cart:', error);
          alert('There was an error adding the product to the cart.');
        }
      });
    });

    //  var utlHash = window.location.hash; 
    // console.log(utlHash);
    // if (utlHash) { 
    //     var linkSelector = utlHash + '-tab';
    //     var $section = $(utlHash);
    //     var $link = $(linkSelector);

    //     if ($section.length) {
    //          var targetScroll = $section.offset().top - 150;
            
    //          targetScroll = targetScroll > 0 ? targetScroll : 0;

    //         $('html, body').animate({
    //             scrollTop: targetScroll
    //         }, 800, function() { 
    //             if ($link.length) {
    //                 $link.click();
    //             }
    //         });
    //     }
    // }



  });